import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['OriginalETAMaster', 'OriginalETAMasterForm'],
});

// Define a service using a base URL and expected endpoints
export const originalETAMasterApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllOriginalETAMasters: builder.query({
      query: () => `route_speed_distances/`,
      keepUnusedDataFor: 0,
      providesTags: ['OriginalETAMaster'],
    }),
    findOriginalETAMasterById: builder.query({
      query: (id) => `route_speed_distances/${id}/`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'OriginalETAMaster', id: result.id }]
          : ['OriginalETAMaster'];
      },
    }),
    findAllOriginalETAMastersByPagination: builder.query({
      query: (payload) => {
        let url = `route_speed_distances/?`;
        let param = '';
        Object.keys(payload).forEach((key) => {
          if (payload[key] != null) {
            param += `&${key}=${payload[key]}`;
          }
        });
        return { url: url + param };
      },
      keepUnusedDataFor: 0,
      providesTags: ['OriginalETAMaster'],
    }),
    findOriginalETAMastersByRouteCode: builder.query({
      query: (id) => `route_speed_distances/next_seq/?route_code=${id}`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'OriginalETAMasterForm', id: result.id }]
          : ['OriginalETAMasterForm'];
      },
    }),
    // findAllLocationMastersByType: builder.query({
    //   query: (name) => ({
    //     url: `route_speed_distances/?location_type__name=${name}`,
    //     method: 'GET',
    //   }),
    //   providesTags: ['OriginalETAMaster'],
    // }),
    createOriginalETAMaster: builder.mutation({
      query: (originalETAMaster) => ({
        url: `route_speed_distances/`,
        method: 'POST',
        body: originalETAMaster,
      }),
      invalidatesTags: ['OriginalETAMasterForm'],
    }),
    updateOriginalETAMaster: builder.mutation({
      query: (originalETAMaster) => ({
        url: `route_speed_distances/${originalETAMaster.id}/`,
        method: 'PATCH',
        body: originalETAMaster,
      }),
      invalidatesTags: ['OriginalETAMasterForm'],
    }),
    deleteOriginalETAMaster: builder.mutation({
      query: (originalETAMaster) => ({
        url: `route_speed_distances/${originalETAMaster.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['OriginalETAMasterForm'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllOriginalETAMastersQuery,
  useFindOriginalETAMasterByIdQuery,
  useFindOriginalETAMasterByRouteCode,
  useFindAllOriginalETAMastersByPaginationQuery,
  useCreateOriginalETAMasterMutation,
  useUpdateOriginalETAMasterMutation,
  useDeleteOriginalETAMasterMutation,
} = originalETAMasterApi;
